import React from "react";
import { compose } from "recompose";
import { Alert } from "reactstrap";

export const AwaitingPayment = () => (
  <div>
    <Alert color="warning">
      Expense claims can only be paid through the main Xero application.
    </Alert>
  </div>
);

export const enhance = compose();

export default enhance(AwaitingPayment);
